<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('purchase.purchaseInfo')" name="detail">
          <div
            class="drawer-content"
            :class="
              purchase &&
              purchase.supplierTenantId != null &&
              !['newly'].includes(purchase.workflowState)
                ? 'with-tab-footer'
                : 'with-tab'
            "
          >
            <el-form
              ref="purchaseForm"
              :model="purchase"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('purchase.serialNo')">
                      <span v-if="purchase.hurry" class="red">
                        ({{ $t("order.hurrySimple") }})
                      </span>
                      {{ purchase.serialNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.workflowState')">
                      <state-label :state="purchase.workflowState">
                        {{ $t("purchaseStates." + purchase.workflowState) }}
                      </state-label>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('menu.suppliers')">
                      {{ purchase.supplierName }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.owner')">
                      {{ purchase.ownerName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">
                      {{ purchase.createAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.handOverAt')">
                      {{ purchase.handOverAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item :label="$t('purchase.giveAt')">
                      {{ purchase.giveAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item
                      :label="$t('purchase.finishAt')"
                      label-width="100px"
                    >
                      {{ purchase.finishAt }}
                    </el-form-item>
                  </el-col>

                  <el-col :span="10">
                    <el-form-item
                      :label="$t('purchase.supplierDeliveryAt')"
                      label-width="140px"
                    >
                      {{ purchase.supplierDeliveryAt }}
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('purchase.settlement')">
                      <span v-if="purchase.settlementId == null">
                        {{ $t("boolean.false") }}
                      </span>
                      <span v-if="purchase.settlementId != null">
                        {{ $t("boolean.true") }}
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="purchase.manualSettleAt != null" :span="6">
                    <el-form-item :label="$t('purchase.manualSettleAt')">
                      {{ purchase.manualSettleAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("order.productInfo") }}
                  <a
                    v-if="purchase.attachment"
                    class="fr blue"
                    target="_blank"
                    :href="purchase.attachment"
                  >
                    {{ $t("action.downloadAttatchment") }}
                  </a>
                </legend>

                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.productNo')">
                      {{ purchase.productNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.category')">
                      {{ purchase.categoryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.brand')">
                      {{ purchase.productBrand }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.color')">
                      <span class="float-left mgr5">{{ purchase.color }}</span>
                      <thumbnail
                        class="mgt5"
                        v-if="purchase.colorImage != null"
                        :images="purchase.colorImage"
                        width="25"
                        height="25"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.size')">
                      {{ purchase.size }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.quantity')">
                      {{ purchase.quantity }} {{ purchase.unit }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    v-if="Permit.canActions('globalPurchasePrice')"
                    :span="8"
                  >
                    <el-form-item :label="$t('purchase.price')">
                      {{ purchase.price }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset
                v-if="
                  purchase.specJson != null &&
                  purchase.specJson != '' &&
                  JSON.parse(purchase.specJson).length != 0
                "
                class="mgb15"
              >
                <legend>{{ $t("product.specJson") }}</legend>
                <el-tag
                  v-for="s in JSON.parse(purchase.specJson)"
                  :key="s.name"
                  type="info"
                  >{{ s.name }}：{{ s.value }}</el-tag
                >
              </fieldset>
              <fieldset v-if="purchase.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail :images="purchase.images" list />
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("product.craftwork") }}</legend>
                <raw-html :content="purchase.craftwork" type="richText" />
              </fieldset>
              <fieldset
                v-if="purchase.remark != null && purchase.remark != ''"
                class="mgb15"
              >
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="purchase.remark" type="richText" />
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("purchase.receiveAdress") }}</legend>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('user.name')">
                      {{ purchase.customerName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('user.phone')">
                      {{ purchase.customerPhone }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('tenant.address')">
                      <span v-if="purchase.country != null">
                        {{ $t("countries." + purchase.customerCountry) }}
                      </span>
                      {{ purchase.customerProvince || "" }}
                      {{ purchase.customerCity || "" }}
                      {{ purchase.customerAddress || "" }}
                      <span
                        v-if="purchase.customerZipcode != null"
                        class="font10"
                      >
                        ({{ purchase.customerZipcode || "" }})
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset v-if="purchase.untreadAt != null" class="mgb15">
                <legend>{{ $t("purchase.untrodInfo") }}</legend>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('purchase.untreadAt')">
                      {{ purchase.untreadAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item :label="$t('purchase.untreadReason')">
                      {{ purchase.untreadReason }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('notice.history')" name="history">
          <div
            class="drawer-content"
            :class="
              purchase &&
              purchase.supplierTenantId != null &&
              !['newly'].includes(purchase.workflowState)
                ? 'with-tab-footer'
                : 'with-tab'
            "
          >
            <div v-if="histories.length == 0" class="noData">暂无消息历史</div>
            <div v-else v-for="history of histories" :key="history.id">
              <div v-if="Permit.currentTenant().id !== history.senderTenantId">
                <div class="mgb10 font10">
                  <span class="mgr10">{{ history.senderName }}</span>
                  <span>{{ history.sendAt }}</span>
                </div>
                <div
                  class="mgl30 mgb20"
                  style="
                    border-top-left-radius: 0px;
                    border-top-right-radius: 15px;
                    border-bottom-right-radius: 15px;
                    border-bottom-left-radius: 20px;
                    background: #f7f7f7;
                    padding: 10px 20px;
                    display: inline-block;
                  "
                >
                  <raw-html :content="history.content" type="richText" />
                </div>
              </div>
              <div v-else>
                <div class="mgb10 font10 float-right">
                  <span class="mgr10">{{ history.senderName }}</span>
                  <span>{{ history.sendAt }}</span>
                </div>
                <div style="clear: both"></div>
                <div
                  class="float-right mgr30 mgb20"
                  style="
                    border-top-left-radius: 15px;
                    border-top-right-radius: 0px;
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 15px;
                    background: #eaf4fc;
                    padding: 10px 20px;
                    display: inline-block;
                  "
                >
                  <raw-html :content="history.content" type="richText" />
                </div>
                <div style="clear: both"></div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      class="drawer-footer"
      v-if="
        purchase &&
        purchase.supplierTenantId != null &&
        !['newly'].includes(purchase.workflowState)
      "
    >
      <el-button
        type="success"
        size="mini"
        @click="sendMessage"
        v-if="purchase != null"
      >
        {{ $t("action.sendMessage") }}
      </el-button>
    </div>

    <!-- 发消息 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.sendMessage')"
      :close-on-click-modal="false"
      :visible.sync="sendMessageDF"
      width="40%"
    >
      <el-form
        ref="sendMessageObjForm"
        :model="sendMessageObj"
        label-width="60px"
      >
        <el-form-item
          :prop="'content'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.content')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('text.content')"
        >
          <tinymce-editor
            ref="editor"
            v-model="sendMessageObj.content"
            :height="150"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="sendMessageSubmitDoing"
          size="small"
          @click="sendMessageSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="sendMessageDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import RawHtml from "@/components/RawHtml";
import Thumbnail from "@/components/Thumbnail";
import StateLabel from "@/components/StateLabel";
import TinymceEditor from "@/components/TinymceEditor";

import Purchase from "@/api/purchase.js";
import Log from "@/api/log.js";
import Notice from "@/api/notice.js";

export default {
  props: {
    uuid: String,
  },
  mixins: [page],
  components: {
    RawHtml,
    Thumbnail,
    StateLabel,
    TinymceEditor,
  },
  data() {
    return {
      activeName: "detail",
      purchase: { workflowState: "newly", serialNo: null, supplierId: null },
      logs: [],
      histories: [],
      //发消息
      sendMessageDF: false,
      sendMessageObj: {
        content: null,
        customerId: null,
        supplierId: null,
        type: null,
        serialNo: null,
      },
      sendMessageSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    //发消息
    sendMessage() {
      const self = this;
      self.sendMessageObj.type = "cus2SupMes";
      self.sendMessageObj.supplierId = self.purchase.supplierId;
      self.sendMessageObj.serialNo = self.purchase.serialNo;
      self.sendMessageObj.content = null;
      self.sendMessageSubmitDoing = false;
      self.sendMessageDF = true;
    },
    sendMessageSubmit() {
      const self = this;
      self.$refs.sendMessageObjForm.validate((valid) => {
        if (valid) {
          self.sendMessageSubmitDoing = true;
          Notice.send(self.sendMessageObj).then(function (res) {
            if (res.status == 200) {
              self.sysResult(res.data);
              self.sendMessageSubmitDoing = false;
              self.sendMessageDF = false;
              self.getHistories();
            } else {
              slef.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getPurchase();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
      if (this.activeName == "history") {
        this.getHistories();
      }
    },
    getPurchase() {
      const self = this;
      self.loadingStart();
      Purchase.findByUuid({ uuid: self.uuid }).then(function (res) {
        if (res.data.code === 200) {
          self.purchase = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getLogs() {
      const self = this;
      Log.forEntity("Purchase", self.purchase.id).then(function (res) {
        self.logs = res.data;
      });
    },
    getHistories() {
      const self = this;
      Notice.findByUuid({ uuid: self.purchase.uuid }).then(function (res) {
        if (res.status == 200) {
          self.histories = res.data;
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>